import { Component, EventEmitter, Output, ViewChild, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiErrorCode, ServiceURLConstants } from "../../../constants/upplm.constants";
import { CATALOG, PICKUP_LOCATION, PLACARD_LOCATION } from "../../../constants/upplm.constants.placardlocation";
import { Catalog } from "../../../interface/upplm.placardconfirmation";
import { PlacardLocation } from "../../../interface/upplm.placardInformation";
import { PlacardLocationStatusResponse } from "../../../interface/upplm.placardLocation";
import { TranslateDataPipe } from "../../../pipes/translation.pipe";
import { PlacardLocationDetailsHelperService } from "../../../services/PlacardEditionServices/upplm.placardLocationDetailsHelper.service";
import { UpplmApiService } from "../../../services/upplm.api.services";
import { UpsCommonService } from "../../../services/upplm.common.service";
import { StoredDataService } from "../../../services/upplm.storedData.service";
import { UpsDialogComponent } from "../../commonComponent/ups-dialog/ups-dialog.component";

@Component({
    selector: 'editplacardlocationdetails',
    template: require('./editPlacardLocationDetails.component.html'),
    providers: [PlacardLocationDetailsHelperService]
})

export class EditPlacardLocationDetailsComponent implements OnInit {

    showEditPlacardLocation: boolean = true;
    isLoading: boolean = false;
    showNotificationChanges: boolean = false;
    errors: any[];
    @ViewChild('errorServerMessage', { static: false }) errorServerMessage: UpsDialogComponent;
    @Output() hideEditSection = new EventEmitter<boolean>();
    locationDetailsForm: FormGroup;
    additionalLocationDetailsMaxLength: number = 40;
    placardLocations: any[];
    placardLocationsBackup: any[];
    pickupLocations: any[];
    messagesErrorServer: string = '';

    private METAL_BOX_KEY: string = 'Metal Box';

    constructor(
        private _storedDataService: StoredDataService,
        private _placardLocationHelperService: PlacardLocationDetailsHelperService,
        private _formBuilder: FormBuilder,
        private _translatePipe: TranslateDataPipe,
        private _apiService: UpplmApiService,
        private _commonService: UpsCommonService
    ) { }

    ngOnInit() {
        this.locationDetailsForm = this._formBuilder.group({
            isPlacedInMetalBox: new FormControl(false, Validators.required),
            lockCombination: new FormControl(''),
            pickupLocation: new FormControl('', Validators.required),
            placardLocation: new FormControl('', Validators.required),
            additionalLocationDetails: new FormControl('', Validators.required)
        });
        this.loadData();
    }

    bindDataFromStoredData(data: PlacardLocation) {

        this.locationDetailsForm.setValue({
            isPlacedInMetalBox: data.metalBoxInd,
            lockCombination: data.lockCombination,
            pickupLocation: this.pickupLocations.find(pl => pl.value == data.pickupLocation).key,
            placardLocation: '',
            additionalLocationDetails: data.additionalLocationDetails
        });

        this.setOrUnsetMetalBoxAsPlacardLocation(this.placardLocations.find(pl => pl.key.toUpperCase() == data.placardLocation.trim() || pl.key == data.placardLocation.trim()).key);
        this.setAdditionalLocationDetailsMaxLength();
    }

    saveEdit() {
        this.isLoading = true;
        this.displayErrors();

        if (this.errors.length == 0) {
            this.saveEditedDataToRequest();
            this.showNotificationsControl(true);
        }
        this.isLoading = false;
    }

    cancel() {
        this._storedDataService.clearEditingSections();
        this.hideEditSection.emit(true);
    }

    displayErrors() {
        this.errors = [];

        if (this.locationDetailsForm.controls.isPlacedInMetalBox.value && this.locationDetailsForm.controls.lockCombination.value == "") {
            this.errors = this.errors.concat(this.addError('lockCombination', this._translatePipe.transform('upplm.placardlocationdetails.lockcombinationrequired'), 'required'));
            this.locationDetailsForm.controls.lockCombination.markAsTouched();
        }

        if (this.locationDetailsForm.controls.pickupLocation.value == "") {
            this.errors = this.errors.concat(this.addError('pickupLocation', this._translatePipe.transform('upplm.placardlocationdetails.pickuplocationrequired'), 'required'));
        }

        if (this.locationDetailsForm.controls.placardLocation.value == "") {
            this.errors = this.errors.concat(this.addError('placardLocation', this._translatePipe.transform('upplm.placardlocationdetails.placardlocationrequired'), 'required'));
        }

        if (this.locationDetailsForm.controls.additionalLocationDetails.value == "") {
            this.errors = this.errors.concat(this.addError('additionalLocationDetails', this._translatePipe.transform('upplm.placardlocationdetails.additionallocationdetailsrequired'), 'required'));
        }
    }

    addError(id: string, field: string, condition: string): any {
        return [{
            "id": id,
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    focusInput(item: any) {
        document.getElementById(item.id).focus();
    }

    private saveEditedDataToRequest() {
        this._storedDataService.requestEditedData = this._placardLocationHelperService.prepareSaveEditionRequest(this.buildObjectForPrepareRequest());
    }

    private buildObjectForPrepareRequest(): PlacardLocation {

        return {
            metalBoxInd: this.locationDetailsForm.controls.isPlacedInMetalBox.value,
            lockCombination: this.locationDetailsForm.controls.lockCombination.value,
            pickupLocation: this.locationDetailsForm.controls.pickupLocation.value,
            placardLocation: this.locationDetailsForm.controls.placardLocation.value,
            additionalLocationDetails: this.locationDetailsForm.controls.additionalLocationDetails.value
        } as PlacardLocation;

    }

    private showNotificationsControl(show: boolean) {
        this.showEditPlacardLocation = !show;
        this.showNotificationChanges = show;
    }

    hideNotificationChange(showNotificationControl: boolean) {

        this.showNotificationsControl(showNotificationControl);

        if (this._storedDataService.isEditionComplete) {
            this.cancel();
        }
    }

    changeValueMetalBox() {
        this.locationDetailsForm.controls.lockCombination.setValue('');
        this.locationDetailsForm.controls.lockCombination.markAsUntouched();
        this.setAdditionalLocationDetailsMaxLength();
        this.validateValueForAdditionalLocationDetails();
        this.setOrUnsetMetalBoxAsPlacardLocation();
    }

    setAdditionalLocationDetailsMaxLength() {
        this.additionalLocationDetailsMaxLength = this.locationDetailsForm.controls.isPlacedInMetalBox.value ? 26 : 40;
    }

    validateValueForAdditionalLocationDetails() {
        let additionalLocationDetailsCurrentValue = this.locationDetailsForm.controls.additionalLocationDetails.value;

        if (additionalLocationDetailsCurrentValue.length > 25) {
            this.locationDetailsForm.controls.additionalLocationDetails.setValue(additionalLocationDetailsCurrentValue.slice(0, 26));
        }
    }

    setOrUnsetMetalBoxAsPlacardLocation(valueToAssign: string = "") {

        if (this.locationDetailsForm.controls.isPlacedInMetalBox.value) {
            this.placardLocations = this.placardLocationsBackup.filter((loc) => loc.key == this.METAL_BOX_KEY);
            valueToAssign = this.METAL_BOX_KEY;
        } else {
            this.placardLocations = this.placardLocationsBackup.filter((loc) => loc.key != this.METAL_BOX_KEY);
        }

        this.locationDetailsForm.controls.placardLocation.setValue(valueToAssign);

        if (valueToAssign == "") { this.locationDetailsForm.controls.placardLocation.markAsTouched(); }
    }

    async loadData() {
        let url = `${ServiceURLConstants.GET_CATALOG}/PICKUP_LOCATION/PLACARD_LOCATION`;

        await this._apiService.getCatalogData(this._commonService.createURL(url, ApiErrorCode.CREATE_PLACARD_CONFIRMATION)).toPromise()
            .then((response: PlacardLocationStatusResponse) => {
                if (response.errors !== null) {
                    if (response.errors[0].message !== '' || response.errors[0].message !== null) {
                        this.messagesErrorServer = this._translatePipe.transform('upplm.common.serviceerror');
                        this.errorServerMessage.open();
                        return;
                    }
                }

                let catalogs: any = response.catalogs ?? [];
                
                let js = JSON.stringify(catalogs);
                let catalog = JSON.parse(js);

                let pickupLocationCatalog = catalog[0];
                let placardLocationCatalog = catalog[1];

                this.pickupLocations = this.getTranslatedCatalog(pickupLocationCatalog.elements, CATALOG.PICKUP_LOCATION);
                this.placardLocations = this.getTranslatedCatalog(placardLocationCatalog.elements, CATALOG.PLACARD_LOCATION);
                this.placardLocationsBackup = [...this.placardLocations];

                this.bindDataFromStoredData(this._storedDataService.placardLocationDetails);
            });

    }

    getTranslatedCatalog(_catalogElements: any[], catalog: string): Catalog[] {

        let catalogTranslated = _catalogElements.map((_element): Catalog => {

            return {
                key: _element.key,
                value: catalog === CATALOG.PLACARD_LOCATION ?
                    this._translatePipe.transform(PLACARD_LOCATION.find(x => x.key === _element.key).value) :
                    this._translatePipe.transform(PICKUP_LOCATION.find(x => x.key === _element.key).value)
            } as Catalog;

        });

        return [{ key: "", value: this._translatePipe.transform('upplm.common.selectone') }, ...catalogTranslated];
    }

    closeErrorMessageServerModal() {
        this.errorServerMessage.close();
        this.cancel();
    }
}